import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7079f91a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "kt_modal_upgrade_plan",
  ref: "selectPlanRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-900px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Atualize seu plano", -1))
const _hoisted_6 = {
  class: "btn btn-sm btn-icon btn-active-color-primary",
  "data-bs-dismiss": "modal"
}
const _hoisted_7 = { class: "svg-icon svg-icon-1" }
const _hoisted_8 = { class: "modal-body py-lg-10 px-lg-10" }
const _hoisted_9 = {
  class: "card bgi-no-repeat card-xl-stretch mb-xl-8",
  style: {"background-position":"right top","background-size":"30% auto","background-image":"url(/media/svg/shapes/abstract-4.svg"}
}
const _hoisted_10 = { class: "card-body d-flex align-items-center pt-3 pb-0" }
const _hoisted_11 = { class: "d-flex flex-column flex-grow-1 py-2 py-lg-13 me-2" }
const _hoisted_12 = { class: "fw-bolder text-dark fs-2 mb-2 text-hover-primary" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fw-bold text-muted fs-3" }, "Você precisa realizar um upgrade de plano para adicionar mais sites.", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "align-self-end h-100px",
  src: "/media/svg/avatars/029-boy-11.svg",
  alt: ""
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, [
              _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("a", _hoisted_12, _toDisplayString(_ctx.$t('SITES.LIMIT_EXCEEDED')), 1),
                _hoisted_13
              ]),
              _hoisted_14
            ])
          ]),
          _createElementVNode("button", {
            class: "btn btn-primary",
            type: "button",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goToPlans && _ctx.goToPlans(...args))),
            "data-bs-dismiss": "modal"
          }, "Ir para planos")
        ])
      ])
    ])
  ], 512))
}